import {useEffect} from 'react';

import {appStore} from '@/entities/app';
import {initInternalAnalytics} from '@/shared/services/analytics';
import {logger} from '@/shared/services/logger';

export function useInternalAnalytics() {
  useEffect(() => {
    (async () => {
      try {
        const {abtests} = await initInternalAnalytics();
        appStore.addSignUpAbTests(abtests);
      } catch (error) {
        logger.warn('Failed to initialize internal analytics', {error});
      }
    })();
  }, []);
}
